import React from 'react';
import { useTranslation } from 'react-i18next';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import './dark-mode-toggle.scss';

export default (props) => {
  const [isDark, setIsDark] = React.useState(
    localStorage.getItem('darkmode') === 'true',
  );
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const { t } = useTranslation('app');
  React.useEffect(() => {
    if (isDark) {
      document.body.classList.add('--dark');
      localStorage.setItem('darkmode', true);
    } else {
      document.body.classList.remove('--dark');
      localStorage.removeItem('darkmode', false);
    }
  }, [isDark]);
  return (
    <Toggle
      className="dark-mode-toggle"
      checked={isDark}
      onChange={({ target }) => setIsDark(target.checked)}
      icons={{
        checked: (
          <span className="md-icon dark-mode-icon" title={t('Dark')}>
            brightness_2
          </span>
        ),
        unchecked: (
          <span className="md-icon light-mode-icon" title={t('Light')}>
            wb_sunny
          </span>
        ),
      }}
      aria-label="Dark mode toggle"
    />
  );
};
